import React from 'react';
import PropTypes from 'prop-types';

class BigNumber extends React.Component {
  render() {
    const NA = 'N/A';
    const round = this.props.round;
    let number = this.props.number;

    if (number == null || number === undefined) { return NA; }

    number = round ? parseInt(number) : number;

    if (Number.isNaN(number)) { return NA; }

    return <React.Fragment>{number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</React.Fragment>;
  }
}
BigNumber.propTypes = {
  number: PropTypes.number.isRequired,
  round: PropTypes.bool,
};

BigNumber.defaultProps = {
  number: 0,
  round: false
};
export default BigNumber;
